import { View } from "react-native";
import empty_camera_snapshot from "src/assets/images/empty_camera_snapshot.jpg";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";

const ShareableNotEnoughPhotos = () => {
	return (
		<View
			style={{
				flex: 1,
				marginTop: paddingLarge,
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Image
				src={empty_camera_snapshot}
				dim={{
					aspectRatio: 1200 / 798,
					height: 200,
				}}
				alt="Empty Camera Snapshot"
			/>
			<Text
				semiLarge
				semibold
				style={{
					marginTop: paddingLarge,
					textAlign: "center",
					alignSelf: "center",
				}}
			>
				A little empty...
			</Text>
			<Text
				color="TextLight"
				style={{
					marginTop: paddingMedium,
					textAlign: "center",
					alignSelf: "center",
				}}
			>
				Add some photos to your album to unlock your recap
			</Text>
		</View>
	);
};
export default ShareableNotEnoughPhotos;
